import styled from 'styled-components';
import { cn } from '@shadcn/lib/utils';
import { Label } from 'components';
import { MASKED_TEXT_CLASS } from 'analytics';

// Replicates the shadcn Textarea's base chrome (border, focus ring, padding) that a bare
// contenteditable div doesn't get for free — see NOTE_EDITOR_CLASS in ResultSection.styles.ts
// for the equivalent used by the other TipTap-based field in this app.
export const TEXT_BUILDING_BLOCK_FIELD_CLASS = cn(
  'tiptap',
  'border-input focus-visible:border-ring focus-visible:ring-ring/50',
  'dark:bg-input/30 w-full rounded-md border bg-transparent text-xs shadow-xs',
  'transition-[color,box-shadow] outline-none focus-visible:ring-[3px]',
  'px-3 py-2 min-h-16',
  MASKED_TEXT_CLASS
);

export const Field = styled.div.attrs({
  className: 'flex flex-col gap-1 text-sm',
})``;

export const FieldLabel = styled(Label).attrs({
  className: 'font-semibold text-xs',
})``;

export const FieldToolbarRow = styled.div.attrs({
  className: 'flex items-end justify-end gap-2',
})``;

export const FieldHelper = styled.p.attrs({
  className: 'min-w-0 flex-1 text-xs text-muted-foreground',
})``;
